export default function isLoudVolume(volumeStats){
    return false // disable too loud condition to let pass

    const { maxVolume, loudThreshold, maxClip} = volumeStats
    if(  maxVolume > loudThreshold && maxClip >= 0.02){
        return true
    }
    return false
}

export function isLoudVolumeButAcceptable(volumeStats){
    const { loudThreshold, maxVolume} = volumeStats
    if(maxVolume > loudThreshold ){
        return true
    }
    return false
}